const QUIZ_FRAGMENT = `
  fragment quiz on Quiz {
    id
    name
  }
`;

export const QUIZZES = `
  query {
    quizzes {
      ...quiz
    }
  }
  ${QUIZ_FRAGMENT}
`;

export const QUIZ = `
  query($id: Int) {
    quiz(id: $id) {
      ...quiz
    }
  }
  ${QUIZ_FRAGMENT}
`;

export const MULTI = `
  query($id: Int) {
    quizzes {
      ...quiz
    }
    quiz(id: $id) {
      ...quiz
    }
  }
  ${QUIZ_FRAGMENT}
`;

export const QUIZ_UPDATE = `
  mutation(
      $id: Int,
      $name: String
  ) {
    quiz: quizUpdate(
      id: $id,
      name: $name
    ) {
      ...quiz
    }
  }
  ${QUIZ_FRAGMENT}
`;
